module.exports = __webpack_public_path__ + "img/logo_zitrus_branco.8017aeb2.png";